import {
  GBI_ANIMAL_FETCH,
  GBI_ANIMAL_FETCH_SUCCESS,
  GBI_ANIMAL_FETCH_FAIL } from './constants';
import { createSelector } from 'reselect';
import { calcScores } from '../cows/reducer';
import { monthsFromDate } from '../util/datesAndAges';
import videoData from '../cows/video/videoData';
import addDocumentsToScores from '../cows/util/addDocumentsToScores';

const initialState = {
  animals: {},
  fetching: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GBI_ANIMAL_FETCH: {
      const fetching = { ...state.fetching };
      fetching[action.id] = true;
      return { ...state, fetching };
    }
    case GBI_ANIMAL_FETCH_SUCCESS: {
      const fetching = { ...state.fetching };
      const animals = JSON.parse(JSON.stringify(state.animals));
      fetching[action.animal.id] = false;
      const animal = JSON.parse(JSON.stringify(action.animal));
      calcScores(animal);
      animal.age = monthsFromDate(animal.dob);
      addDocumentsToScores(animal, action.scoreDefinitions);
      if (animal.orgId === '5d0dee629bf92c2352b9961b') {
        animal.video = { ...videoData['Warson Video'] };
      }
      animals[action.animal.id] = animal;
      return { ...state, fetching, animals };
    }
    case GBI_ANIMAL_FETCH_FAIL: {
      const fetching = { ...state.fetching };
      fetching[action.id] = false;
      return { ...state, fetching };
    }
  }
  return state;
};

const animals = state => state.animals.animals;
const fetching = state => state.animals.fetching;

export const getAnimalsObj = createSelector(
  animals, animals => animals
);

export const getFetchingAnimalsObj = createSelector(
  fetching, fetching => fetching
);

export default reducer;
